import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'

// CSS
import './BackToOverview.css'

class BackToOverview extends Component {

    static propTypes = {
        url: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
    }

    render() {

        return (
            <div className="back-to-overview">
                <NavLink to={this.props.url}>{this.props.text}</NavLink>
            </div>
        )

    }
}

export default BackToOverview;



// WEBPACK FOOTER //
// ./src/components/backtooverview/BackToOverview.js